import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  getToken,
  getUser,
  setUserSession,
  removeUserSession,
} from "../../../Utils/Common";
import { useSelector, useDispatch } from "react-redux";
import { setUserCredits } from "../../../features/counter/counterSlice";
import "./account.css";

function AccountDetail() {
  const [subscription, setSubscription] = useState({});
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const user = getUser();
  const token = getToken();
  const [errorMessage, setErrorMessage] = useState("");
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    //Check to see if this is a redirect back from Checkout
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}v1/user/get-subscription`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setStatus(200);
          console.log(response.data.data);
          setSubscription(response.data.data);
          setUserSession(token, response.data.user);
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        if (error.response.status === 500) {
          console.log(error.response);
          setStatus(500);
        } else if (error.response.status === 401) {
          setStatus(401);
          console.log(error.response);
        } else if (error.response.status === 404) {
          setStatus(404);
          console.log(error.response.data.message);
          setMessage(error.response.data.message);
        } else {
        }
      });
  }, []);

  const createSubscriptionWithOutTrial = () => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/create-subscription`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        price: "price_1KqA6YHuNOGPY9ja3ze6NQZ1",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          window.location.replace(response.data.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          console.log(error.response);
        } else if (error.response.status === 401) {
          console.log(error.response);
        } else if (error.response.status === 404) {
          console.log(error.response.data.message);
          setMessage(error.response.data.message);
        } else {
        }
      });
  };

  const createSubscriptionWithTrial = () => {
    setLoader(true);
    const user = getUser();
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/create-subscription`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        price: "price_1KhY8bHuNOGPY9jaCIulrQ90",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          window.location.replace(response.data.data);
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          console.log(error.response);
        } else if (error.response.status === 401) {
          console.log(error.response);
        } else if (error.response.status === 422) {
          console.log(error.response.data.message);
          setMessage(error.response.data.message);
        } else {
        }
      })
      .then(() => {
        setLoader(false);
      });
  };

  const moveTo = () => {
    navigate("/account/cancellation");
  };

  const handleLogout = () => {
    removeUserSession();
    navigate("/login");
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <div className={loader === true ? "spinner-border" : ""} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>

      {status && status === 404 ? (
        <div
          className="d-flex flex-column flex-root"
          style={{ marginTop: "140px" }}
        >
          <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
            <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
              <div style={{ textAlign: "center" }}>
                {/* <p style={{ color: "red", fontSize: "20px" }}>{message}</p> */}
              </div>
              <div className="w-lg-450px bg-body rounded border-black p-lg-5">
                <div className="col-12 text-center">
                  <img
                    src="/images/logo-short.png"
                    style={{ width: "125px" }}
                  />
                  <p>
                    <strong>Premium Membership</strong>
                    <br />
                    Regular Price: $9.99/mo
                  </p>
                </div>

                <div className="col-12">
                  <strong>What do I get?</strong>
                  <ul>
                    <li>
                      1 credit a month good for any title in our entire premium
                      selection, yours to keep
                    </li>
                    <li>No commitments. Cancel Anytime</li>
                    <li>A montly zoom meeting book club</li>
                  </ul>
                </div>
              </div>
              <div className="mx-auto mt-3 mb-3">
                <button
                  onClick={createSubscriptionWithTrial}
                  className="btn btn-dark w-300px"
                  type="button"
                >
                  Start Now
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {status && status === 200 ? (
        <div
          className="border d-flex align-items-center justify-content-center bg-white"
          style={{ height: "900px" }}
        >
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-12 fs-2hx fw-bolder">
                  <span>Subscription Status: </span>
                  <span>{subscription.status}</span>
                </div>
              </div>

              <div className="row">
                <div className="col-12 fs-2hx"></div>
              </div>

              <div className="row mt-10">
                <div className="col-12">
                  {subscription.status === "active" ? (
                    <div className="row">
                      <div className="col-5 no-padding">
                        <button
                          className="button-active fs-2 fw-bolder"
                          disabled
                        >
                          Renew Subscription
                        </button>
                      </div>
                      <div className="col-2 fs-1 text-gray-400 fw-bolder text-center fs-3tx no-padding">
                        /
                      </div>
                      <div className="col-5 no-padding">
                        <button
                          onClick={moveTo}
                          className="button-active fs-2 fw-bolder"
                          disabled={subscription.status === "canceled"}
                        >
                          Cancel Subscription
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-5">
                        <button
                          onClick={createSubscriptionWithOutTrial}
                          className="button-active"
                          disabled={subscription.status === "active"}
                        >
                          Renew Subscription
                        </button>
                      </div>
                      <div className="col-2 fs-1 text-gray-400 fw-bolder text-center fs-3tx no-padding">
                        /
                      </div>
                      <div className="col-5">
                        <button className="button-active" disabled>
                          Cancel Subscription
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="row mt-10 text-center">
                <div className="col-12">
                  <div className="row">
                    <div className="col-5 no-padding">
                      <button
                        onClick={handleLogout}
                        className="button-active fs-2"
                      >
                        Logout
                      </button>
                    </div>
                    <div className="col-2 fs-1 text-gray-400 fw-bolder text-center fs-3tx no-padding">
                      {/* / */}
                    </div>
                    <div className="col-5 no-padding">
                      {/* <button
                        onClick={moveTo}
                        className="button-active fs-2 fw-bolder"
                        disabled={subscription.status === "canceled"}
                      >
                        Cancel Subscription
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-10 text-center">
                <div className="mt-10 fs-1">
                  <Link to={`/account/change-password`}>Change Password</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default AccountDetail;
